<template>
  <div v-if="showTab === 4">
    <md-card-content>
      <table class="flex-table td-text-align-right">
        <tr>
          <th>분담금 합계</th>
          <td>{{ formatter.getCurrency(executiveTotalSum.count) }} 건</td>
          <td>{{ formatter.getCurrency(executiveTotalSum.amount) }} 원</td>
        </tr>
      </table>
      <div class="md-layout">
        <div class="md-layout-item md-size-50 no-padding">
          <h4>납부 구분별</h4>
<!--
          <table class="flex-table td-text-align-right" style="overflow-y: auto; height:200px;">
            <tr>
              <th>납부방법</th>
              <th>분담금</th>
              <th>납입건수</th>
              <th>납입금액</th>
            </tr>
            <tr v-for="item in executiveDataByGb" :key="item.id">
              <td>{{ item.feeWayNm }}</td>
              <td>{{ formatter.getCurrency(item.orgAmt) }} 원</td>
              <td class="clickable" @click="executiveQueryByType(item,1)">
                {{ formatter.getCurrency(item.feeCnt) }} 건
              </td>
              <td>{{ formatter.getCurrency(item.feeAmt) }} 원</td>
            </tr>
          </table>
-->

          <md-table :value="executiveDataByGb" class="paginated-table table-striped table-hover text-align-center h-scroll h510">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="납부방법">{{ item.feeWayNm }}</md-table-cell>
              <md-table-cell md-label="분담금" style="text-align: right;">{{ formatter.getCurrency(item.orgAmt) }} 원</md-table-cell>
              <md-table-cell md-label="납입건수" style="text-align: right; color:#0091d5; cursor:pointer;" @click.native="executiveQueryByType(item,1)">{{ formatter.getCurrency(item.feeCnt) }} 건</md-table-cell>
              <md-table-cell md-label="납입금액" style="text-align: right;">{{ formatter.getCurrency(item.feeAmt) }} 원</md-table-cell>
<!--              <md-table-cell md-label="납입일" style="text-align: right;">{{ item.feeDate }} </md-table-cell>-->
            </md-table-row>
          </md-table>

        </div>
        <div class="md-layout-item md-size-50 no-padding">
          <h4>직위별</h4>

<!--

          <table class="flex-table td-text-align-right">
            <tr>
              <th>직위</th>
              <th>분담금</th>
              <th>납입건수</th>
              <th>납입금액</th>
            </tr>
            <tr v-for="item in executiveDataByLevel" :key="item.id">
              <td>{{ item.feeWayNm }}</td>
              <td>{{ formatter.getCurrency(item.orgAmt) }} 원</td>
              <td class="clickable" @click="executiveQueryByType(item,2)">
                {{ formatter.getCurrency(item.feeCnt) }} 건
              </td>
              <td>{{ formatter.getCurrency(item.feeAmt) }} 원</td>
            </tr>
          </table>
-->


          <md-table :value="executiveDataByLevel" class="paginated-table table-striped table-hover text-align-center h510">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="직위" style="text-align: center;">{{ item.feeWayNm }}</md-table-cell>
              <md-table-cell md-label="분담금" style="text-align: right;">{{ formatter.getCurrency(item.orgAmt) }} 원</md-table-cell>
              <md-table-cell md-label="납입건수" style="text-align: right; color:#0091d5; cursor:pointer;" @click.native="executiveQueryByType(item,2)">{{ formatter.getCurrency(item.feeCnt) }} 건</md-table-cell>
              <md-table-cell md-label="납입금액" style="text-align: right;">{{ formatter.getCurrency(item.feeAmt) }} 원</md-table-cell>
<!--              <md-table-cell md-label="납입일" style="text-align: right;">{{ item.feeDate }} </md-table-cell>-->
            </md-table-row>
          </md-table>

        </div>
      </div>
    </md-card-content>
    <md-card-content>
      <div class="table-header-info">
        <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
        <div>
          <select v-model="pagination.perPage" name="pages" @change="perPageChange">
            <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
              {{ item }}
            </option>
          </select>
        </div>
      </div>

      <grid ref="paymentListGrid"
            :data="gridProps.data"
            :columns="gridProps.columns"
            :options="gridProps.options"
            :theme="gridProps.theme"
            :rowHeaders="gridProps.rowHeaders"
            :columnOptions="gridProps.columnOptions"
            :language="gridProps.lang"
            @response="response"
      ></grid>

    </md-card-content>
    <md-card-actions md-alignment="space-between">
      <div class="md-alignment-space-between-right">
        <md-button class="md-success md-sm" :disabled="this.pagination.total === 0" @click="downloadExcel(item)" v-exel-btn="[5,3]">
          <md-icon>get_app</md-icon>
          Excel 다운로드
        </md-button>
      </div>
    </md-card-actions>
  </div>
</template>
<script>

import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import formatter from "@/kuaa/kuaa-formatter";
import { Grid } from '@toast-ui/vue-grid';
import moment from "moment";
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';

import Swal from "sweetalert2";
import kuaaFnc from "@/kuaa/kuaa-comm-func";

export default {
  name: "PaymentListExecutiveComp",
  props: {
    showTab : {
      type : Number,
      default : 1
    },
    queryData : {
      type : Object
    }
  },
  components: {
    grid: Grid
  },

  created() {
    this.initGrid();
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },
  data() {
    return {
      formatter,

      executiveTotalSum: {
        count: 0,
        amount: 0
      },
      executiveDataByGb: [],
      executiveDataByLevel: [],
      executiveData: [],
      pagination: {
        perPage: 20,
        page: 1,
        perPageOptions: [20, 50, 100, 200, 500],
        total: 0
      },
      option: {
      	levelCd : "",
        feeAmt : "",
        feeWay : "",
        feeCd : ""
      }
    };
  },
  methods: {
    resetExecutiveTotalSum (){
      this.executiveTotalSum = {
        count: 0,
        amount: 0
      };
    },
    sendQuery (query) {
      this.option = query ? query : {};
      this.option['feeGb'];
      this.option['feeCd'] = query.feeCd;
      this.executiveDataByGb = [];
      this.executiveDataByLevel = [];
      kuaaApi.sendServer(
        URL_CONST.GET_FEE_LIST_TOTAL,
        this.option,
        "post",
        (response) => {
          let resContents = response.data.data.contents.orgFeeTotalInfo;
          this.resetExecutiveTotalSum();

          resContents.forEach((obj)=>{
            if(!obj['orgAmt'] || obj['orgAmt'] == ''){
              obj['orgAmt'] = 0;
            }
            if(obj['clssfyType'] == "feeWay"){
	            this.executiveTotalSum['count'] += obj['feeCnt']; // 분담금 합계
	            this.executiveTotalSum['amount'] += obj['feeAmt']; // 분담금 합계
			      }
            if(obj['clssfyType'] == 'feeWay'){ // 납부구분별
              this.executiveDataByGb.push(obj);
            }
            else if(obj['clssfyType'] == 'orgNm'){ // 직위별
              this.executiveDataByLevel.push(obj);
            }
          });
          this.queryData.startDate = this.queryData.startDate != '' ? moment(this.queryData.startDate).format("YYYYMMDD") : this.queryData.startDate;
          this.queryData.endDate = this.queryData.endDate != '' ? moment(this.queryData.endDate).format("YYYYMMDD") : this.queryData.endDate;
          this.$refs.paymentListGrid.invoke("readData", 1, this.queryData);
        }
      );
    },
    executiveQueryByType (item,type) {
      let params = {};
      if(type==1){
        params['feeWay'] = item['feeWay'];
        params['levelCd'] = null;
        params['feeAmt'] = item['orgAmt'].toString();
        params['feeCd'] = this.option['feeCd'];
        this.option.levelCd = null;
        this.option.feeAmt = item.feeAmt.toString();
        this.option.feeWay = item.feeWay;
      }else{
        params['levelCd'] = item['feeWay'];
        params['feeWay'] = null;
        params['feeAmt'] = item['orgAmt'].toString();
        params['feeCd'] = this.option['feeCd'];
        this.option.levelCd = item.levelCd;
        this.option.feeAmt = item.feeAmt.toString();
        this.option.feeWay = null;
      }
      params['startDate'] = this.option.startDate;
      params['endDate'] = this.option.endDate;
      this.$refs.paymentListGrid.invoke("readData", 1, params);
    },
    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.paymentListGrid, event, this.pagination);
    },
    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_ORG_FEE_LIST, false, this.pagination);
      this.gridProps['el'] = this.$refs.executivesGrid;
      this.gridProps['columns']= [
        {header: '교우번호', name: 'memberNo', align:"center", sortable: true},
        {header: '교우명', name: 'memberHnm', sortable: true},
        {header: '교우직위', name: 'orgNm', align:"center", sortable: true},
        {header: '대학명', name: 'collegeNm', align:"center", sortable: true},
        {header: '학과명', name: 'classNm', sortable: true},
        {header: '학번', name: 'hakbun', align:"center", sortable: true},
        {header: '졸업회수', name: 'graduationNo', align:"center", sortable: true},
        {header: '입학년도', name: 'enterYm', align:"center", sortable: true,
          formatter(value) {
            return (value.value && value.value.length == 6) ? formatter.getDateFormat(value.value) : value.value;
          }
        },
        {header: '졸업년도', name: 'graduationYm', align:"center", sortable: true,
          formatter(value) {
            return (value.value && value.value.length == 6) ? formatter.getDateFormat(value.value) : value.value;
          }
        },
        {header: '회비구분', name: 'feeCdNm', align:"center", sortable: true},
        {header: '납부일자', name: 'lastFeeDate', align:"center", sortable: true},
        {header: '납부년도', name: 'lastFeeYear', align:"center", sortable: true},
        {header: '납부방법', name: 'feeWayNm', align:"center", sortable: true},
        {header: '납부금액', name: 'feeAmt', align:"right", sortable: true,
          formatter(value) {return value.value ? formatter.getCurrency(value.value) : null;}
        },
        {header: '휴대폰', name: 'cellular', align:"center", sortable: true},
        {header: '이메일', name: 'eMail'}
        ];
    },
    response(e) {
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
      }else{
        kuaaFnc.gridErrorCallback(e,"임원 납부리스트");
      }
    },
    downloadExcel(item) {
      if(this.pagination.total > 100000){
        kuaaFnc.showSwal("엑셀 다운로드", "다운로드 대상은 100,000건 이하여야 합니다.");
        return false;
      }
      
      this.option.page = 1;
      this.option.perPage = this.pagination.total;
      this.option.fileName = '납부상세내역(임원_납부리스트)';      
      kuaaApi.requestFileDownload(
          URL_CONST.FEE_LIST_EXCEL_DOWNLOAD,
          this.option,
          '납부상세내역(임원_납부리스트).xlsx',
          response => {
            this.option.page = this.pagination.page;
            this.option.perPage = this.pagination.perPage;
          }
      );
    }
  }
};
</script>

<style lang="css" scoped>

</style>